import SubscriptionSection from "../../components/systemPage/SubscriptionSection";
import SearchHeader from "../../components/main/SearchHeader";
import Loading from "../../components/atoms/Loading";
import Table2 from "../../components/main/Table/Table2";
import {HeaderSystem} from "../../data/TablesHeader";
import ListsOperations from "../../tools/consts";
import Pagination from "../../components/main/Pagination";
import DeleteModal from "../../components/atoms/DeleteModal";
import AddModalsystem from "../../components/systemPage/AddModalsystem";
import {Toaster} from "react-hot-toast";
import React from "react";
import {useConfigContext} from "./ConfigContext";
import {list} from "postcss";
import TableSearchHeader from "../../components/CustomTable/TableSearchHeader";
import AddWarrantyModal from "../../components/systemPage/AddWarrantyModal";
import WarrantyListSection from "./component/WarrantyListSection";
import ReleaseApplicationSecion from "./component/ReleaseApplicationSecion";

const ConfigScreen = () => {



    return (
        <>
            <div className="pb-7.5px ">
                <SubscriptionSection/>
                <ReleaseApplicationSecion/>
                <WarrantyListSection/>


            </div>
        </>
    );
}
export default ConfigScreen